/* Furniva Coins on the product page and in the cart (snippets/furniva-coins.liquid).

   Signed out, the snippet's own words stand: the offer and a sign-in link.
   Signed in, it asks the account Worker for the wallet (/api/coins) and says
   what this customer can do here:

     product — how much of this piece the coins could pay, and what it earns back;
     cart    — the same for the order, and a button that reserves the coins as
               a one-time code (/api/coins/redeem) and applies it to the cart.
               Razorpay Magic Checkout opens with it as its coupon
               (snippets/furniva-checkout-code.liquid).

   Nothing about the wallet is stored in the browser; it is asked for on each
   page and held in this closure. */
(function () {
  'use strict';

  if (!document.querySelector('[data-fv-coins]')) return;
  var cached = null;

  var SHARE = 0.05;
  var PER = 100;
  var fmt = function (n) { return new Intl.NumberFormat('en-IN').format(Math.max(0, Math.round(n))); };
  var esc = function (text) { var d = document.createElement('div'); d.textContent = String(text); return d.innerHTML; };
  var arrow = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';

  function account() { return window.FurnivaAccount; }

  function walletLink() {
    var a = account();
    return (a && a.accountUrl ? a.accountUrl() : '/pages/account') + '?tab=wallet';
  }

  function paintProduct(block, coins) {
    var total = Number(block.getAttribute('data-total')) || 0;
    var use = Math.min(coins.balance, Math.floor(total * SHARE));
    var back = Math.floor(total / PER);
    var line = use > 0
      ? '<strong>' + fmt(coins.balance) + ' Furniva Coins</strong> · Use up to ₹' + fmt(use) + ' on this piece' + (back > 0 ? ', and earn ' + fmt(back) + ' back.' : '.')
      : '<strong>Furniva Coins</strong> · Earn ' + fmt(back) + ' coins back on this piece.';
    body(block).innerHTML = '<p class="fv-coins__line">' + line + '</p>' +
      '<a class="fv-coins__act" href="' + walletLink() + '">Wallet' + arrow + '</a>';
  }

  function paintCart(block, coins) {
    var total = Number(block.getAttribute('data-total')) || 0;
    var use = Math.min(coins.balance, Math.floor(total * SHARE));
    var back = Math.floor(total / PER);
    var cart = window.FurnivaCart;
    var onCart = coins.hold && cart && cart.codes().some(function (c) { return c.toUpperCase() === coins.hold.code.toUpperCase(); });

    // Already on the order: the summary shows the deduction; say so here.
    if (onCart) return paintCode(block, coins.hold, back);

    if (use <= 0) {
      body(block).innerHTML = '<p class="fv-coins__line"><strong>Furniva Coins</strong> · You will earn ' + fmt(back) + ' coins back on this order.</p>' +
        '<a class="fv-coins__act" href="' + walletLink() + '">Wallet' + arrow + '</a>';
      return;
    }
    body(block).innerHTML =
      '<p class="fv-coins__line"><strong>₹' + fmt(use) + ' of your coins</strong> can go towards this order — you have ' + fmt(coins.balance) + '. You also earn ' + fmt(back) + ' back.</p>' +
      '<button type="button" class="fv-coins__use" data-fv-coins-use>Use ₹' + fmt(use) + ' in coins</button>';
    block.querySelector('[data-fv-coins-use]').addEventListener('click', function (event) { redeem(block, event.currentTarget); });
  }

  function paintCode(block, hold, back) {
    block.classList.add('is-applied');
    var withCoupon = hold.coupon
      ? '<strong>₹' + fmt(hold.amount) + ' of your coins and ' + esc(hold.coupon) + ' (₹' + fmt(hold.couponAmount) + ') are on this order</strong>, as one code. '
      : '<strong>₹' + fmt(hold.amount) + ' of your coins are on this order.</strong> ';
    body(block).innerHTML =
      '<p class="fv-coins__line">' + withCoupon + 'You will still earn ' + fmt(back) + ' back.</p>' +
      '<button type="button" class="fv-coins__undo" data-fv-coins-undo>Keep my coins</button>' +
      '<p class="fv-coins__fine">Shown in your order summary, and checkout opens with it applied. If it is not there when you pay, enter ' + esc(hold.code) + ' under Coupons.</p>';
    block.querySelector('[data-fv-coins-undo]').addEventListener('click', function (event) {
      var button = event.currentTarget;
      button.disabled = true;
      account().request('/api/coins/release', { body: { code: hold.code } })
        .then(function (result) {
          if (result.data && result.data.ok) cached = result.data;
          // Off the order too; the cart redraws and the block repaints. A
          // coupon that rode on the code goes back on the cart by itself.
          if (!window.FurnivaCart) return;
          var off = window.FurnivaCart.removeCode(hold.code);
          if (hold.coupon) off.then(function () { return window.FurnivaCart.addCode(hold.coupon); });
        })
        .catch(function () { button.disabled = false; });
    });
  }

  /* Razorpay Magic Checkout takes ONE code from the cart. So the coupon on the
     cart (SAVE10, CART3) travels inside the coins code: the Worker makes one
     code worth both, and it replaces the coupon on the cart (owner,
     2026-10-30: coins stack with any one coupon). `coupon` is given when a
     coupon is added while coins are already on. */
  function redeem(block, button, coupon) {
    if (button) {
      button.disabled = true;
      button.textContent = 'Reserving your coins…';
    }
    var cart = window.FurnivaCart;
    var onCart = cart ? cart.codes().filter(function (c) { return !/^FC-/i.test(c); })[0] : null;
    var withCoupon = coupon || onCart || null;
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : {}; })
      .catch(function () { return {}; })
      .then(function (live) {
        var subtotal = Math.floor((Number(live.original_total_price) || 0) / 100);
        return account().request('/api/coins/redeem', {
          body: { total: Number(block.getAttribute('data-total')) || 0, subtotal: subtotal, coupon: withCoupon }
        });
      })
      .then(function (result) {
        var data = result.data || {};
        if (data.ok) cached = data;
        // On the cart itself: it redraws with the deduction in the summary,
        // and this block repaints from `cached` (paintAll). A code carrying
        // the coupon replaces everything; a coins-only one sits beside it.
        if (data.ok && data.code && cart) return data.coupon ? cart.replaceCodes([data.code]) : cart.addCode(data.code);
        if (data.ok) return paintCart(block, data);
        if (button) {
          button.disabled = false;
          button.textContent = 'Try again';
        }
        say(block, data.error || 'Coins could not be used just now.');
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          button.textContent = 'Try again';
        }
        say(block, 'No connection. Your coins are safe.');
      });
  }

  // For furniva-cart.js: a coupon added while coins are on the cart.
  window.FurnivaCoins = {
    stack: function (coupon) {
      var block = document.querySelector('[data-fv-coins="cart"]');
      if (!block || !account()) return Promise.resolve();
      return redeem(block, null, coupon);
    }
  };

  function say(block, text) {
    var fine = block.querySelector('.fv-coins__fine') || document.createElement('p');
    fine.className = 'fv-coins__fine is-error';
    fine.textContent = text;
    body(block).appendChild(fine);
  }

  function body(block) { return block.querySelector('[data-fv-coins-body]'); }

  function start() {
    var a = account();
    if (!a || !a.isSignedIn || !a.isSignedIn()) return;
    a.request('/api/coins')
      .then(function (result) {
        var coins = result.data;
        if (!coins || !coins.ok) return;
        cached = coins;
        paintAll();
        // The cart redraws itself when a quantity changes, bringing back the
        // signed-out markup with the new total; paint each new one too.
        if ('MutationObserver' in window) {
          new MutationObserver(function () { paintAll(); }).observe(document.body, { childList: true, subtree: true });
        }
      })
      .catch(function () { /* the signed-out line stays: still true, just general */ });
  }

  function paintAll() {
    if (!cached) return;
    document.querySelectorAll('[data-fv-coins]:not([data-fv-coins-painted])').forEach(function (block) {
      block.setAttribute('data-fv-coins-painted', '');
      if (block.getAttribute('data-fv-coins') === 'cart') paintCart(block, cached);
      else paintProduct(block, cached);
    });
  }

  if (window.FurnivaAccount) start();
  else document.addEventListener('furniva:account-ready', start, { once: true });
})();
